var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NxSelectReduced',{attrs:{"value":_vm.localValue,"options":_vm.listOptions,"labelText":"Periodicidade:","id":"selectPeriodicidade","placeholder":"Selecione a Periodicidade","multiple":false},on:{"update:value":_vm.handleValueUpdate}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d52d3f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/custom-selects/NxSelectPeriodicidade.vue
// module id = null
// module chunks = 